import { _COLORS } from "../../../utils/constants";
export const excelStylesIncrease = [
  {
    id: "month-header",
    interior: {
      color: _COLORS.headerAgGrid,
      pattern: "Solid",
    },
  },
];

/**
 * Converts form data into a row format suitable for display or further processing.
 *
 * @param {Object} inputRateIncreaseGroup - The input rate increase group data.
 * @param {Array} activities - The list of activities, each containing sites.
 * @param {Object} params - Additional parameters for processing.
 * @returns {Array} An array of row objects, each representing a site with its associated activity and months data.
 */
export const formDataToRow = (inputRateIncreaseGroup, activities, params) => {
  const rowMap = new Map();

  activities.forEach(({ sites, name: activityName, id: activityId }) => {
    sites.forEach(({ id: siteId, name: siteName }) => {
      const [months, inputRateIncreaseGroupId] = getMonthsValue(
        inputRateIncreaseGroup,
        activityId,
        siteId,
        params,
      );

      const key = `${activityId}-${siteId}`;
      rowMap.set(key, {
        id: null,
        site: siteName,
        siteId,
        activity: activityName,
        activityId,
        months: months,
        inputRateIncreaseGroupId,
        group: activityName,
      });
    });
  });

  return Array.from(rowMap.values());
};

/**
 * Retrieves the percentage increase values for each month based on the provided parameters.
 *
 * @param {Array} inputRateIncreaseGroup - The array of input rate increase objects.
 * @param {number} activityId - The ID of the activity.
 * @param {number} siteId - The ID of the site.
 * @param {Object} options - Additional options.
 * @param {number} options.fiscalYear - The fiscal year to filter by.
 * @param {number} [options.version=1] - The version to filter by (default is 1).
 * @returns {[Object, number|null]} - An array containing the months object with fiscal months as keys and percentage increases as values, and the ID of the matched input rate increase group or null if not found.
 */
export const getMonthsValue = (
  inputRateIncreaseGroup,
  activityId,
  siteId,
  { fiscalYear, version = 1 },
) => {
  const months = {};
  const inputRateIncreaseGroupId = {};
  inputRateIncreaseGroup.forEach(
    ({
      pcIncrease,
      fiscalMonth,
      fiscalYear: fy,
      version: ver,
      activity,
      site,
      id,
    }) => {
      if (
        fiscalYear === fy &&
        version === ver &&
        activityId === activity.id &&
        siteId === site.id
      ) {
        months[fiscalMonth] = pcIncrease;
        inputRateIncreaseGroupId[fiscalMonth] = id;
      }
    },
  );

  return [months, inputRateIncreaseGroupId];
};
